import { useFeeScheduleProgramMetafields } from 'common/hooks/useFeeScheduleProgramMetafields';

const useMetafields = (invoice) => {
  const { metafields } = useFeeScheduleProgramMetafields(invoice.fee_schedule_program_id);
  return metafields;
};

export default useMetafields;
